import { useState } from "react";

const useNav = () => {
  const [navigation, setNavigation] = useState<boolean>(false)

  const updateNavigation = () => {
    setNavigation(!navigation)
  }

  return {
    navigation,
    updateNavigation
  }
}

export default useNav;